
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import TipsPopup from '@/components/tipsPopup/index.vue'
import { periodTypeList, statusTypeList, formatDate } from './../index'
import { confirmActivity, confirmActivityAgain } from '@/api/marketActivity'
import { handleFill } from '@/utils/util'

@Component({
  components: { TipsPopup }
})
class ActivityCard extends Vue {
  @Getter companyId!: string
  @Prop({ default: () => {} }) data: any

  handleFill = handleFill

  tipsPopupHtmlContent = ''

  // 获取状态标签
  get statusLabel() {
    const { status = 1 } = this.data
    const item = statusTypeList.find((s) => s.value === Number(status))
    return item.label || '--'
  }

  // 获取周期类型标签
  get periodTypeLabel() {
    const { periodType = 1 } = this.data
    const item = periodTypeList.find((p) => p.value === Number(periodType))
    return item.label || '--'
  }

  // 抽奖时间文本
  get lotteryTimeText() {
    const { lotteryStartTime = '', lotteryEndTime = '' } = this.data

    if (!lotteryStartTime || !lotteryEndTime) return '--'
    return `${formatDate(lotteryStartTime)} 至 ${formatDate(lotteryEndTime)}`
  }

  onDetail() {
    this.$router.push({
      path: '/marketActivityDetail',
      query: {
        lotteryId: this.data.lotteryId,
        activityName: this.data.lotteryName
      }
    })
  }

  onConfirm() {
    confirmActivity({
      storeId: this.companyId,
      lotteryId: this.data.lotteryId
    })
      .then((res) => {
        if (Number(res?.data) === 1) {
          this.tipsPopupHtmlContent = `<P>${
            res?.msg || '活动已超过开始时间，是否继续开展活动？'
          }</P>`
          ;(this.$refs.tipsPopupRef as any).showPopup()
        } else {
          this.$emit('confirmSuccess')
          this.$toast('确认成功')
        }
      })
      .catch(() => {
        this.$toast('确认失败')
      })
  }

  // 二次确认
  onTipsCallback(isConfirm: number) {
    const isConfirmText = isConfirm === 1 ? '确认' : '取消'
    confirmActivityAgain({
      storeId: this.companyId,
      lotteryId: this.data.lotteryId,
      isConfirm // 1确认 0取消
    })
      .then(() => {
        this.$emit('confirmSuccess')
        this.$toast(`${isConfirmText}成功`)
      })
      .catch(() => {
        this.$toast(`${isConfirmText}失败`)
      })
  }
}
export default ActivityCard
